import i18nISOCountries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

i18nISOCountries.registerLocale(en);

const countryOptions = Object.entries(i18nISOCountries.getNames('en'))
  .map(([value, label]) => ({ label, value }))
  .sort((a, b) => a.label.localeCompare(b.label));

interface ISouthAfricanProvinceOption {
  label: string;
  value: string;
}

const southAfricanProvinceOptions: ISouthAfricanProvinceOption[] = [
  { label: 'Eastern Cape', value: 'Eastern Cape' },
  { label: 'Free State', value: 'Free State' },
  { label: 'Gauteng', value: 'Gauteng' },
  { label: 'KwaZulu-Natal', value: 'KwaZulu-Natal' },
  { label: 'Limpopo', value: 'Limpopo' },
  { label: 'Mpumalanga', value: 'Mpumalanga' },
  { label: 'Northern Cape', value: 'Northern Cape' },
  { label: 'North West', value: 'North West' },
  { label: 'Western Cape', value: 'Western Cape' },
].sort((a, b) => (a.label > b.label ? 1 : -1));

export { countryOptions, southAfricanProvinceOptions };
